/* eslint-disable react/prop-types */
import classes from "./announcement-modal.module.scss";
import Flex from "@/components-library/layout/flex";
import Label from "@/components-library/widgets/label";
import classNames from "classnames";
import Grid from "@/components-library/layout/grid";
import * as announcementHelper from "@/common/announcement-helper";
function AnnouncementModal({
  title,
  description,
  className,
  onCloseClick,
  status,
  promoting,
  cities,
  beneficiary,
  outgoings,
  types,
  granted,
  dateLabel,
  date,
  maxContribution,
}) {
  return (
    <Flex
      align="flex-start"
      direction="column"
      justify="flex-start"
      className={classNames(classes.container, className)}
    >
      <img
        src={"/images/icons/icon-close.svg"}
        alt="close"
        className={classes.iconClose}
        onClick={onCloseClick}
      />
      <Label
        weight="bold"
        tag="h3"
        color="default"
        align="start"
        className={classes.title}
      >
        {title}
      </Label>
      <Label
        align="start"
        size="md"
        color="default"
        className={classes.description}
      >
        {description}
      </Label>
      <Grid columns="1fr 1fr" className={classes.main}>
        <Flex
          align="flex-start"
          direction="column"
          justify="flex-start"
          className={classes.subContainerLeft}
        >
          <Label
            weight="bold"
            align="start"
            size="sm"
            color="default"
            className={classNames(classes.status, {
              [classes.closed]: status === announcementHelper.Status.CLOSED,
              [classes.opened]: status === announcementHelper.Status.OPEN,
              [classes.reporting]:
                status === announcementHelper.Status.REPORTING,
              [classes.activating]:
                status === announcementHelper.Status.ACTIVATING,
            })}
          >
            Stato bando: {status}
          </Label>
          <Grid columns="1fr 1fr" className={classes.rowDetailDate}>
            <Label tag="p" size="sm" color="default" align="start">
              {dateLabel}
            </Label>
            <Label
              tag="p"
              size="sm"
              color="default"
              align="start"
              weight="bold"
            >
              {date}
            </Label>
          </Grid>
          <Grid columns="1fr 1fr" className={classes.rowDetail}>
            <Label tag="p" size="sm" color="default" align="start">
              Ente promotore:
            </Label>
            <Label
              tag="p"
              size="sm"
              color="default"
              align="start"
              weight="bold"
            >
              {promoting ? promoting : announcementHelper.PROPERTY_PLACEHOLDER}
            </Label>
          </Grid>
          <Grid columns="1fr 1fr" className={classes.rowDetail}>
            <Label tag="p" size="sm" color="default" align="start">
              Area geografica:
            </Label>
            <Label
              tag="p"
              size="sm"
              color="default"
              align="start"
              weight="bold"
            >
              {cities}
            </Label>
          </Grid>
          <Grid columns="1fr 1fr" className={classes.rowDetail}>
            <Label tag="p" size="sm" color="default" align="start">
              Tipologia agevolazione:
            </Label>
            <Label
              tag="p"
              size="sm"
              color="default"
              align="start"
              weight="bold"
            >
              {types ? types : announcementHelper.PROPERTY_PLACEHOLDER}
            </Label>
          </Grid>
          <Grid columns="1fr 1fr" className={classes.rowDetail}>
            <Label tag="p" size="sm" color="default" align="start">
              Beneficiari:
            </Label>
            <Label
              tag="p"
              size="sm"
              color="default"
              align="start"
              weight="bold"
            >
              {beneficiary
                ? beneficiary
                : announcementHelper.PROPERTY_PLACEHOLDER}
            </Label>
          </Grid>
          <Grid columns="1fr 1fr" className={classes.rowDetail}>
            <Label tag="p" size="sm" color="default" align="start">
              Spese finanziate:
            </Label>
            <Label
              tag="p"
              size="sm"
              color="default"
              align="start"
              weight="bold"
            >
              {outgoings ? outgoings : announcementHelper.PROPERTY_PLACEHOLDER}
            </Label>
          </Grid>
        </Flex>
        <Flex
          align="flex-start"
          direction="column"
          justify="flex-start"
          className={classNames(classes.subContainerRight)}
        >
          <Grid columns="1fr 1fr" className={classes.rowDetail}>
            <Label tag="p" size="sm" color="default" align="start">
              Massimo contributo ottenibile:
            </Label>
            <Label
              tag="p"
              size="sm"
              color="default"
              align="start"
              weight="bold"
            >
              {maxContribution
                ? maxContribution
                : announcementHelper.PROPERTY_PLACEHOLDER}
            </Label>
          </Grid>
          <Label tag="p" size="sm" color="default" align="start">
            Agevolazione prevista:
          </Label>
          <Label tag="p" size="sm" color="default" align="start" weight="bold">
            {granted ? granted : announcementHelper.PROPERTY_PLACEHOLDER}
          </Label>
        </Flex>
      </Grid>
    </Flex>
  );
}

export default AnnouncementModal;
